var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Aspect_ } from '../../../../components/actor/Aspect_';
import { runtime } from '../../../../classes/runtime/Runtime';
let AttachedSound_ = class AttachedSound_ extends React.PureComponent {
    get color() {
        const { sound } = this.props;
        if (sound.isSndPlaying) {
            return 'blue';
        }
        return undefined;
    }
    get speakerClassName() {
        const { sound } = this.props;
        if (sound.isSndPlaying) {
            return 'fas fa-volume-up animated infinite pulse';
        }
        return 'fas fa-volume-up';
    }
    render() {
        const { sound } = this.props;
        return (React.createElement(Aspect_, { aspect: sound.inner, templateComponent: React.createElement("div", { style: {
                    flex: '1 1 50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: this.color,
                    cursor: 'pointer'
                }, onMouseEnter: sound.playNow, onClick: sound.playNow }) },
            React.createElement("i", { className: this.speakerClassName })));
    }
    componentDidMount() {
        runtime.solidBrowserRuntime.browserIncludes.includeCSSFileOnce('/lib/cssAnimations/animateAttention.css');
    }
};
AttachedSound_ = __decorate([
    observer
], AttachedSound_);
export { AttachedSound_ };
